import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const PixelBurstAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number
) => {
  const count = 40;
  for (let i = 0; i < count; i++) {
      const angle = (i / count) * Math.PI * 2;
      const dist = e.maxRadius + progress * 200;
      const r = getRadiusAtAngle(angle, e, dist);
      const size = 10 * (1 - progress);
      const px = clampX(e.pos.x + Math.cos(angle) * r - size/2);
      const py = clampY(e.pos.y + Math.sin(angle) * r - size/2);
      ctx.fillRect(px, py, size, size);
  }
};

registerBlastAnimation('PIXEL_BURST', PixelBurstAnimation);
